
				<div class="login-form login-forgot">
					<!--begin::Form-->
					<form
						class="form fv-plugins-bootstrap fv-plugins-framework"
						novalidate="novalidate"
						[formGroup]="changePasswordForm"
						(ngSubmit)="changePassword()"
						id="kt_login_forgot_form"
						[ngStyle]="{
							display: errorState === errorStates.NoError ? 'none' : 'block'
						}">
						<!--begin::Title-->
						<div class="pb-13 pt-lg-0 pt-5">
							<h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">Nueva Contraseña</h3>
							<p class="text-muted font-weight-bold font-size-h4">Inserte una nueva contraseña para ingresar a su cuenta</p>
						</div>
						<!--end::Title-->

						<!-- begin::Alert error-->
						<ng-container *ngIf="errorState === errorStates.HasError">
							<div class="mb-10 alert alert-custom alert-light-danger alert-dismissible">
								<div class="alert-text">Error al intentar cambiar de contraseña</div>
							</div>
						</ng-container>
						<!-- end::Alert error-->

						<!--begin::Form group-->
						<div class="form-group fv-plugins-icon-container has-danger">
							<input
								type="password"
								class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
								formControlName="tempPassword"
								placeholder="Ingresar su contraseña temporal"
								name="temporalPassword"
								autocomplete="off"
								[ngClass]="{
									'is-invalid': changePasswordForm.controls['tempPassword'].invalid && changePasswordForm.controls['tempPassword'].touched
								}" />
							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'required',
									message: 'Campo requerido',
									control: changePasswordForm.controls['tempPassword']
								}"></ng-container>
							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'minlength',
									message: 'La contraseña debe contener al menos 8 carácteres',
									control: changePasswordForm.controls['tempPassword']
								}"></ng-container>
							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'maxlength',
									message: 'La contraseña puede tener como máximo 32 carácteres',
									control: changePasswordForm.controls['tempPassword']
								}"></ng-container>
							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'pattern',
									message: 'La contraseña debe contener por lo menos 1 minúscula, 1 mayúscula y 1 un número',
									control: changePasswordForm.controls['tempPassword']
								}"></ng-container>
						</div>
						<!--ned::Form group-->
						<!--begin::Form group-->
						<div class="form-group fv-plugins-icon-container has-danger">
							<input
								class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
								type="password"
								formControlName="password"
								placeholder="Ingresar nueva contraseña"
								name="password"
								autocomplete="off"
								[ngClass]="{
									'is-invalid': changePasswordForm.controls['password'].invalid && changePasswordForm.controls['password'].touched
								}" />

							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'required',
									message: 'Campo requerido',
									control: changePasswordForm.controls['password']
								}"></ng-container>
							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'minlength',
									message: 'La contraseña debe contener al menos 8 carácteres',
									control: changePasswordForm.controls['password']
								}"></ng-container>
							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'maxlength',
									message: 'La contraseña puede tener como máximo 32 carácteres',
									control: changePasswordForm.controls['password']
								}"></ng-container>
							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'pattern',
									message: 'La contraseña debe contener por lo menos 1 minúscula, 1 mayúscula y 1 un número',
									control: changePasswordForm.controls['password']
								}"></ng-container>
						</div>
						<!--end::Form group-->
						<!--begin::Form group-->
						<div class="form-group fv-plugins-icon-container has-danger">
							<input
								class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
								type="password"
								formControlName="repeatPassword"
								placeholder="Repetir nueva contraseña"
								name="password"
								autocomplete="off"
								[ngClass]="{
									'is-invalid': changePasswordForm.controls['repeatPassword'].invalid && changePasswordForm.controls['repeatPassword'].touched
								}" />

							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'required',
									message: 'Campo requerido',
									control: changePasswordForm.controls['repeatPassword']
								}"></ng-container>
							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'minlength',
									message: 'La contraseña debe contener al menos 8 carácteres',
									control: changePasswordForm.controls['repeatPassword']
								}"></ng-container>
							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'maxlength',
									message: 'La contraseña puede tener como máximo 32 carácteres',
									control: changePasswordForm.controls['repeatPassword']
								}"></ng-container>
							<ng-container
								[ngTemplateOutlet]="formError"
								[ngTemplateOutletContext]="{
									validation: 'pattern',
									message: 'La contraseña debe contener por lo menos 1 minúscula, 1 mayúscula y 1 un número.No debe contener simbolos',
									control: changePasswordForm.controls['repeatPassword']
								}"></ng-container>
						</div>
						<!--end::Form group-->
						<ng-container
							[ngTemplateOutlet]="formError"
							[ngTemplateOutletContext]="{
								validation: 'differentPassword',
								message: 'La contraseña debe coincidir',
								control: changePasswordForm
							}"></ng-container>
						<!--begin::Form group-->
						<div class="form-group d-flex flex-wrap pb-lg-0">
							<button type="submit" id="kt_login_forgot_submit" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4">Enviar</button>
							<a routerLink="/auth/login" id="kt_login_forgot_cancel" class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"> Cancelar </a>

							<ng-container *ngIf="isLoading$ | async">
								<span class="spinner spinner-primary ml-5"></span>
							</ng-container>
						</div>
						<!--end::Form group-->
						<div></div>
					</form>
					<!--end::Form-->

					<ng-container *ngIf="errorState === errorStates.NoError">
						<div class="card card-custom bgi-no-repeat gutter-b" style="height: 175px; background-color: #4ab58e; background-position: calc(100% + 1rem) bottom; background-size: 25% auto; background-image: url(assets/media/svg/humans/custom-1.svg)">
							<!--begin::Body-->
							<div class="card-body d-flex align-items-center">
								<div class="py-2">
									<h3 class="text-white font-weight-bolder mb-3">Contraseña válida</h3>
									<p class="text-white font-size-lg">
										Puede volver a ingresar a su<br />
										cuenta con esta nueva contraseña<br />
									</p>
									<a routerLink="/auth/login" class="swal2-confirm btn font-weight-bold btn-light-primary"> Aceptar </a>
								</div>
							</div>
							<!--end::Body-->
						</div>
					</ng-container>
				</div>

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
	<ng-container *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
		<div class="fv-plugins-message-container">
			<div class="fv-help-block">
				{{ message }}
			</div>
		</div>
	</ng-container>
</ng-template>
<swal #currentSwal icon="info" title="Operación realizada" text="Se ha realizado correctamente la operación" (confirm)="returnToLogin()"></swal>
<swal #errorSwal icon="error" title="Operación fallida" text="No es posible realizar la operación"></swal>
